










































































import $router from "@/router";
import store from "@/store";
import LoadingScreen from "@/components/LoadingScreen.vue";
import Vue from "vue";
import { FooterSettings } from "@/models";
import LazyImage from "@/components/LazyImage.vue";

const footerSettings: FooterSettings = {
  prevText: "finish.footer.prev",
  prevAction: function() {
    store.commit("setLoading", {
      loading: true,
      loadingText: "",
      transition: "slide-right"
    });
    $router.push("/");
  },
  prevVisible: true,
  prevEnabled: true,
  nextText: "finish.footer.next",
  nextAction: undefined,
  nextVisible: false,
  nextEnabled: false
};

export default Vue.extend({
  name: "Finish",
  components: { LoadingScreen, LazyImage },
  mounted() {
    store.commit("changeFooter", footerSettings);
    footerSettings.nextEnabled = false;
  }
});
